import React, { useState } from 'react';
import './QuickQuestion.css';
import { apiFetch } from '../services/api';
import { trackQuickQuestion } from '../services/googleAds';

/**
 * Inline quick-question form for product detail pages.
 * Customer submits email + question. They get a confirmation email,
 * and the admin gets a notification with Reply-To set to the customer
 * so a direct Reply in their inbox goes back to the customer.
 */
function QuickQuestion({ productName, productSlug }) {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!email.trim() || !message.trim()) {
      setError('Please enter your email and a question.');
      return;
    }
    if (message.trim().length < 5) {
      setError('Please enter a longer question.');
      return;
    }

    setSubmitting(true);
    try {
      const res = await apiFetch('/api/contacts/quick-question', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: email.trim(),
          message: message.trim(),
          product_name: productName,
          product_slug: productSlug,
        }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        setError(data.error || 'Something went wrong. Please try again.');
        setSubmitting(false);
        return;
      }
      trackQuickQuestion();
      setSubmitted(true);
    } catch (err) {
      setError('Network error. Please try again.');
      setSubmitting(false);
    }
  };

  if (submitted) {
    return (
      <div className="qq-card qq-card-success">
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" style={{ stroke: 'var(--asg-cta)' }} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
          <path d="M22 4 12 14.01l-3-3" />
        </svg>
        <h3>Question received</h3>
        <p>Thanks - we've sent a confirmation to <strong>{email}</strong>. We'll reply within <strong>1 business day</strong>.</p>
      </div>
    );
  }

  return (
    <div className="qq-card">
      <h3>Quick question?</h3>
      <p className="qq-subtitle">Email us about <strong>{productName}</strong>. We usually reply in <strong>1 business day</strong>.</p>
      <form onSubmit={handleSubmit} noValidate>
        <input
          type="email"
          className="qq-input"
          placeholder="Your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          disabled={submitting}
          autoComplete="email"
        />
        <textarea
          className="qq-textarea"
          placeholder={`Anything you'd like to know about the ${productName}? Sizing, colours, fabric, lead time...`}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          rows={4}
          required
          disabled={submitting}
        />
        {error && <p className="qq-error">{error}</p>}
        <button type="submit" className="qq-submit" disabled={submitting}>
          {submitting ? 'Sending...' : 'Send question'}
        </button>
        <p className="qq-foot">We reply within 1 business day.</p>
      </form>
    </div>
  );
}

export default QuickQuestion;
